<template>
    <div class="wrapper">
        <div
            ref="el"
            class="tooltip-layout"
            role="tooltip"
        >
            <div class="header">
                <slot name="title"></slot>

                <button
                    class="close-button"
                    @click="close"
                ></button>
            </div>

            <div class="content">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useTemplateRef } from 'vue'

import { useHandleEscapeKey } from '@/composables/ui/useHandleEscapeKey'

const emit = defineEmits<{
    close: []
}>()

const el = useTemplateRef('el')

defineExpose({ el })

const close = () => emit('close')
useHandleEscapeKey(close)
</script>

<style lang="scss" scoped>
.wrapper {
    position: fixed;
    z-index: 4000;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    text-transform: none;
}

.tooltip-layout {
    position: absolute;
    width: 600px;
    max-width: calc(100% - 40px);
    background-color: $stone-3;
    box-shadow: 0 0 40px rgba($black, 0.2);
    pointer-events: all;
    color: $slate;

    .header {
        position: relative;
        min-height: 50px;
        display: flex;
        align-items: center;
        font-size: 18px;
        padding: 25px;
        font-family: $parcel-font-stack;
        color: $blue;

        @include border-bottom;

        .close-button {
            color: $slate;
            top: 15px;
            right: 15px;
            @include close-button;
        }
    }

    .content {
        padding: 10px 10px 100px;
        max-height: 80vh;
        overflow-y: auto;

        @include min-width(640) {
            padding: 20px 25px 25px;
        }
    }
}
</style>
